import React, { Component } from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import couterpart from 'counterpart';
import {MdDeleteForever, MdFilter1} from 'react-icons/md';
import {ToastsContainer, ToastsStore} from 'react-toasts';
import {ICON_COLOR} from '../icon';

import AuthenticationService from '../services/AuthenticationService';
import MasterDataService from '../services/MasterDataService';
import "../css/style.css";
import DataUtil from '../utilities/DataUtil';
import Spinner from 'react-spinner-material';

class DesignImageList extends Component {
  constructor () {
    super();
    this.state = {
      imageName: undefined,
      spinnerVisible: false,
      desigImages: [],
      columns : [
        {
          id: "idx",
          accessor: "",
          width: 40,
          Cell: row =>(
            <div style={{ padding: "10px"}}>{row.index + 1}</div>
          )
        },        
        {
            Header: couterpart.translate('design_image_name'),
            accessor: 'name',
                     
        },
        {
            Header: couterpart.translate('design_image_content'),
            accessor: 'content',
            Cell: row =>(
              this.renderImage(row)
            )
        },{                     
            Header: couterpart.translate('work_order_action'),
            accessor: 'action',
            width: 50,
            Cell: row =>(
              <div style={{ textAlign: "center" }}>
                  {this.renderEditButton(row)}
              </div>
            )
        }
        ]
    };
  }

  renderEditButton(row){
    // const button_edit = couterpart.translate('button_edit');
    const button_delete = couterpart.translate('button_delete');
    if (AuthenticationService.isAdmin() || AuthenticationService.isService()){
      return (<div>
              <button className="myButton" onClick={() => this.handleDelete(row)}>
              <MdDeleteForever color={ICON_COLOR}/>
              &nbsp;{button_delete}</button>
                </div>
              );
    }else{
      return (<></>);
    }
  }

  handleDelete(e){
    MasterDataService.deleteUploadImage(e.original.id).then(data => {
      if (data.message === undefined){
        MasterDataService.fetchDesignImages({ imageName: this.state.imageName }).then(data => {
          if (data.message === undefined){
            this.setState({ desigImages:  data })
          }else{
            this.setState({ desigImages:  [] })
          }
        });
      }
    });
  }

  renderImage(row){
    if (row.original.content === undefined || row.original.content === null){
      return (<></>)
    }    
    return(
        <img className="imageBox linkTo" alt="" width={ 100 } height={70} src={`data:image/jpeg;base64,${row.original.content}`} name={ 'B' + row.original.name} />
    )
  } 

  componentDidMount () {
    MasterDataService.fetchDesignImages({ imageName: this.state.imageName }).then(data => {
      if (data.message === undefined){
        this.setState({ desigImages:  data })
      }else{
        this.setState({ desigImages:  [] })
      }
    });
      
  } 

  handleChange(e){
    if (e.key === 'Enter') {
      this.onFilter()
      return;
    }    
    var value = e.target.value;
    this.setState({ imageName :  value});
  }

  onFilter () {
    MasterDataService.fetchDesignImages({ imageName: this.state.imageName }).then(data => {
      if (data.message === undefined){
        this.setState({ desigImages:  data })
      }else{
        this.setState({ desigImages:  [] })
      }
    });
  }

  onDownload() {
    try{
      this.setState({ spinnerVisible: true }, () => {
          MasterDataService.downloadImages({ imageName: this.state.imageName }).then(data => {
            const downloadUrl = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', "design_imges.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
            DataUtil.sleep(1000).then(() => { this.setState({ spinnerVisible: false }); });
          });
      });
    } catch(e) {
        this.sleep(100).then(() => {this.setState({spinnerVisible: false});});
    }
  }

  render() {
    if (!AuthenticationService.isAdmin() && !AuthenticationService.isService()){
      return (<div>Unauthorized access.</div>);
    }
    return (
      <>
        <div className="row">
          <div className="col-7">
            &nbsp;
          </div>
          <div className="col-1">
            <label style={{ margin: "5px", width: "100%"}}>{ couterpart.translate('design_image_name') }</label>
          </div>
          <div className="col-2">
            <input name="duration" type="text" size="40" style={{ margin: "5px", width: "100%"}}
              placeholder="" value={this.state.imageName}
              onChange={this.handleChange.bind(this)} onKeyDown = {(e) => { e.persist(); setTimeout(() => { this.handleChange(e) }, 0); }}  />
          </div>
          <div className="col-1">
            <button className="myButton" onClick={() => this.onFilter()} style={{ marginBottom: "10px"}}>
              <MdFilter1 color={ICON_COLOR}/>
              &nbsp;{ couterpart.translate('button_filter') }</button>
          </div>
          <div className='col-1'>
            <button className="myButton" onClick={() => this.onDownload()} style={{ marginBottom: "10px"}}>
              <MdFilter1 color={ICON_COLOR}/>
              &nbsp;{ couterpart.translate('button_download') }</button>
          </div>
        </div>
         <div className="row">
          <div className="col-7">
            &nbsp;
          </div>
          <div className="col-5">
            <Spinner size={25} spinnerColor={ICON_COLOR} spinnerWidth={2} visible={this.state.spinnerVisible} />
          </div>
         </div>
        <div className="row">
          <div className="col-12">
            <ReactTable
              NoDataComponent={() => null} 
              previousText={"<"}
              nextText={">"}
              data={this.state.desigImages}
              columns={this.state.columns}
              defaultPageSize = {3}
              showPageSizeOptions = {true}                
              pageSizeOptions = {[3, 5, 10, 20]}
              getTrProps={(state, rowInfo, column) => { 
                if (rowInfo && rowInfo.row) {
                  return {
                    onClick: (e) => {
                      this.setState({
                        selectedRow: rowInfo.index
                      });                      
                    },
                    style: {
                      background: rowInfo.index === this.state.selectedRow ? '#DCDCDC' : 'white',
                      color: rowInfo.index === this.state.selectedRow ? 'white' : 'black'
                    }
                  }
                }else{
                  return {}
                }
              }
            }
            />
          </div>
        </div>
      </>
    )
  }
}

export default DesignImageList;